<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="short_text_black_24dp 1" clip-path="url(#clip0_2545_14987)">
<g id="Group">
<g id="Group_2">
<g id="Group_3">
<path id="Vector" d="M2.66675 6H13.3334V7.33333H2.66675V6ZM2.66675 8.66667H9.33342V10H2.66675V8.66667Z" fill="#888888"/>
</g>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_2545_14987">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
